import { useCurrentUser } from "@hooks";

interface FeatureActivation {
  featureName: string;
  isActivated: boolean;
}

interface ActivationMap {
  [key: string]: boolean;
}

export function useUserActivations() {
  const { data: userData, refetch } = useCurrentUser();

  const featureActivations = (
    userData?.user?.featureActivations || []
  ).filter(
    (a): a is NonNullable<typeof a> => a !== null,
  ) as FeatureActivation[];

  const activationMap: ActivationMap =
    featureActivations.reduce<ActivationMap>((acc, activation) => {
      acc[activation.featureName] = activation.isActivated;
      return acc;
    }, {});

  // For now, this just refetches the current user
  // but depending on future feature activations, we may need to update this
  const refetchActivations = async () => {
    await refetch();
  };

  return {
    isScribephoneActivated: activationMap.scribephone || false,
    refetchActivations,
  };
}
